import { Button, ButtonType, TextInput } from '@resurs-internal/styx-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../common/utils'
import styles from './Mock.module.scss'
import { useIsInternal } from './useIsInternal'
import { UseRealServiceButton } from './UseRealServiceButton'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

export const MockAuthentication = () => {
  const { token } = useParams()
  const { altUrl } = useQuery()
  const [govId, setGovId] = useState('')
  const [isDisabled, setIsDisabled] = useState(false)
  const [initiated, setInitiated] = useState(false)
  const isInternal = useIsInternal()

  useEffect(() => {
    if (!token) {
      setInitiated(true)
      return
    }
    fetch(`${proxyPath}/checkpoint-mock/authentication/${token}/session`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (data?.governmentId) {
          setGovId(data.governmentId)
          setIsDisabled(true)
        }
        setInitiated(true)
      })
      .catch(() => setInitiated(true))
  }, [token])

  if (!initiated) return <p>Loading...</p>

  const doAuth = action => {
    let url = `${proxyPath}/mock/${action}?resursToken=${encodeURIComponent(token)}`
    if (govId) url += `&govId=${encodeURIComponent(govId)}`
    window.location.href = url
  }

  return (
    <>
      <h1>Authentication</h1>
      {isDisabled ? (
        <p>The government ID of the authenticating person is</p>
      ) : (
        <p>Enter government ID of authenticating person</p>
      )}
      <div className={styles.lineWrapper}>
        <TextInput
          id="govId"
          label="Government ID"
          value={govId}
          disabled={isDisabled}
          onChange={(_, value) => setGovId(value)}
        />
      </div>
      <div className={styles.lineWrapper}>
        <Button id="successButtonId" fullWidth onClick={() => doAuth('doAuth')}>
          Authenticate
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="failureButtonId"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => doAuth('failAuth')}
        >
          Cancel
        </Button>
      </div>
      {!altUrl && token && (
        <div className={styles.lineWrapper}>
          <Button
            id="signicatButtonId"
            type={ButtonType.Secondary}
            fullWidth
            onClick={() => doAuth('authToSignicat')}
          >
            Use Signicat
          </Button>
        </div>
      )}
      {isInternal && token && (
        <UseRealServiceButton
          apiPath={`${proxyPath}/checkpoint-romeo-authentication/${token}/use_real_service`}
        />
      )}
    </>
  )
}
